<template>
  <v-app>
    <RouterView />
    <RDPToast />
  </v-app>
</template>

<script setup lang="ts">
import { onBeforeMount, onMounted } from 'vue';
import { useAuthStore } from '@/store/useAuthStore';
import { useShoppingCartStore } from '@/store/useShoppingCartStore';
import loadSystemConfiguration, { loadPublicSystemConfiguration } from '@/utils/systemConfiguration';
import { loadSupportedLocales } from '@/utils/i18n';
import RDPToast from '@/components/common/RDPToast.vue';
import accountService from './services/api/accountService';

const authStore = useAuthStore();
const shoppingCartStore = useShoppingCartStore();

onBeforeMount(async () => {
  await loadSupportedLocales();
  if (authStore.logged && !authStore.tokenExpired) {
    await loadSystemConfiguration();
    const accountCartLifetime = await accountService.getCustomerAccountCartLifetime();
    if (accountCartLifetime.data.cartLifetime) {
      shoppingCartStore.setExpirationTime(accountCartLifetime.data.cartLifetime);
      shoppingCartStore.setCartLifetimeTimer();
    }
  } else {
    await loadPublicSystemConfiguration();
  }
});

onMounted(() => {
  // this event is only fired when persisted vuex storage changes in other tabs
  // it means that on login or logout, the other tabs are refreshed
  // this prevents from two different users being logged-in in two different tabs - see RDP-330
  globalThis.addEventListener('storage', event => {
    const oldValue = JSON.parse(event.oldValue as string);
    const newValue = JSON.parse(event.newValue as string);

    // reload the page only on customer change, not on any change of the storage - @see RDP-501
    // if customer changed, it means new user is logged in or sub-account was switched
    // compare the customers on their email (aka username) - @see RDP-1063
    if (oldValue && newValue && oldValue.auth?.username !== newValue.auth?.username) {
      // timeout is needed otherwise the cypress tests won't work
      setTimeout(() => location.reload(), 100);
    }
  });
});
</script>

<style lang="scss">
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) .v-icon {
  color: #757575 !important;
}

.row {
  margin: 0 -12px;
}

html {
  overflow-y: auto !important;
}
</style>
